var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.calendarOpen && !_vm.isMobile,
            expression: "!calendarOpen && !isMobile",
          },
        ],
        staticClass: "container-input",
        on: { click: _vm.openCalendar },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", [
          _vm.availableDates.length <= 0
            ? _c("i", [_vm._v("Nenhuma data disponível")])
            : _c("span", { staticStyle: { color: "#757575" } }, [
                _vm._v(_vm._s(_vm.dataFormatada)),
              ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.availableDates.length <= 0 && _vm.isMobile
      ? _c("div", [_c("i", [_vm._v("Nenhuma data disponível")])])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.availableDates.length > 0 &&
              (_vm.calendarOpen || _vm.isMobile),
            expression:
              "availableDates.length > 0 && (calendarOpen || isMobile)",
          },
        ],
        staticStyle: { "margin-left": "-20px", "margin-right": "-20px" },
      },
      [
        _c("v-calendar", {
          attrs: {
            translate: "no",
            columns:
              !_vm.isMobile && _vm.calendarSize == 2
                ? _vm.$screens({ default: 1, xsm: 2 })
                : 1,
            rows:
              !_vm.isMobile && _vm.calendarSize == 2
                ? _vm.$screens({ default: 2, xsm: 1 })
                : 1,
            attributes: _vm.calendarAttr,
            "available-dates": _vm.filteredAvailableDatesParsed,
            "from-date": _vm.startDate,
            "min-page": _vm.minPage,
            "max-date": _vm.maxDateNoAvailability,
            transiton: "none",
            "is-expanded": "",
          },
          on: {
            "update:to-page": _vm.onCalendarPageUpdate,
            "update:from-page": _vm.onCalendarPageUpdate,
            dayclick: _vm.diaSelecionado,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: (_vm.calendarOpen || _vm.isMobile) && _vm.monthsLoading > 0,
            expression: "(calendarOpen || isMobile) && monthsLoading > 0",
          },
        ],
        staticStyle: {
          position: "relative",
          top: "-30px",
          overflow: "visible",
          height: "1px",
          "text-align": "right",
        },
      },
      [_c("i", { staticClass: "fa-regular fa-hourglass" })]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "font-size": "14px" } }, [
      _c("i", { staticClass: "fa-solid fa-calendar-days" }),
      _vm._v("\n          \n      "),
      _c("strong", [_vm._v("DATA")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }